import { render } from "./PreviewAccountingReceipt.vue?vue&type=template&id=90bb3c38&scoped=true&ts=true"
import script from "./PreviewAccountingReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewAccountingReceipt.vue?vue&type=script&lang=ts"

import "./PreviewAccountingReceipt.vue?vue&type=style&index=0&id=90bb3c38&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90bb3c38"]])

export default __exports__